import { NumericFormat } from 'react-number-format';

const FIELDS = [
    { key: 'pAC',          label: 'For. AC',    type: 'currency', variant: 'planned' },
    { key: 'ac',           label: 'AC',          type: 'currency', variant: 'actuals' },
    { key: 'pINV',         label: 'For. INV',   type: 'currency', variant: 'planned' },
    { key: 'inv',          label: 'INV',         type: 'currency', variant: 'actuals' },
    // { key: 'pEV',          label: 'For. EV',    type: 'currency', variant: 'planned' },
    { key: 'ev',           label: 'EV',          type: 'currency', variant: 'actuals' },
    { key: 'forecastHours',label: 'For. Hours', type: 'hours',   variant: 'planned' },
    { key: 'actualHours',  label: 'Act. Hours', type: 'hours',   variant: 'actuals' },
    // { key: 'hoursBuffer',  label: 'Hours Buffer', type: 'hours',   variant: 'planned' },
];


const KpiCard = ({ label, value, type, settings, variant }) => {
    const renderValue = () => {
        if (value === null || value === undefined) return <span className="kpi-card-empty">—</span>;

        if (type === 'currency') {
            return (
                <NumericFormat
                    value={value}
                    displayType="text"
                    prefix={settings.currencySymbol}
                    thousandSeparator={settings.groupSeparator}
                    decimalSeparator={settings.decimalSeparator}
                    decimalScale={2}
                    fixedDecimalScale
                />
            );
        }

        if (type === 'percentage') {
            return (
                <NumericFormat
                    value={value}
                    displayType="text"
                    suffix="%"
                    thousandSeparator={settings.groupSeparator}
                    decimalSeparator={settings.decimalSeparator}
                    decimalScale={2}
                    fixedDecimalScale
                />
            );
        }

        if (type === 'hours') {
            return (
                <NumericFormat
                value={value}
                displayType="text"
                suffix=" h"
                thousandSeparator={settings.groupSeparator}
                decimalSeparator={settings.decimalSeparator}
                decimalScale={2}
                fixedDecimalScale
            />
            );
        }

        return (
            <NumericFormat
                value={value}
                displayType="text"
                thousandSeparator={settings.groupSeparator}
                decimalSeparator={settings.decimalSeparator}
                decimalScale={2}
                fixedDecimalScale
            />
        );
    };

    return (
        <div className={`kpi-card kpi-card--${variant}`}>
            <span className="kpi-card-label">{label}</span>
            <span className="kpi-card-value">{renderValue()}</span>
        </div>
    );
};

const CashFlowKPIBar = ({ kpis, view, settings = { currencySymbol: '$', groupSeparator: ',', decimalSeparator: '.' } }) => {
    const data = view === 'ytd' ? kpis?.ytd : kpis?.monthly;

    return (
        <div className="kpi-bar">
            <div className="kpi-cards-area">
                <div className="kpi-row">
                    {FIELDS.map(f => (
                        <KpiCard
                            key={f.key}
                            label={f.label}
                            value={data?.[f.key]}
                            type={f.type}
                            settings={settings}
                            variant={f.variant}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CashFlowKPIBar;
